import React, { FC } from 'react'

const RightArrowIcon: FC = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12.312' height='12' viewBox='0 0 12.312 12'>
      <path
        d='M5.235,3.451l.61-.61a.657.657,0,0,1,.932,0L12.118,8.18a.657.657,0,0,1,0,.932L6.776,14.454a.657.657,0,0,1-.932,0l-.61-.61a.66.66,0,0,1,.011-.943L8.557,9.746H.659A.658.658,0,0,1,0,9.087V8.208a.658.658,0,0,1,.659-.659h7.9L5.246,4.394A.655.655,0,0,1,5.235,3.451Z'
        transform='translate(0 -2.647)'
        fill='currentColor'
      />
    </svg>
  )
}

export default RightArrowIcon
